import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { StorageMovement } from '../../../../../core/interfaces/storage-movements';

@Component({
  selector: 'storage-movement-card',
  templateUrl: './storage-movement-card.component.html',
  styleUrls: ['./storage-movement-card.component.scss']
})
export class StorageMovementCardComponent implements OnInit {
  @Input() storageMovement: StorageMovement;
  @Input() previousDate: string;

  public isSameDayThanPrevious = false;

  public createdByAvatarUrl: string = null;
  public createdByName: string = null;

  public storageMovementType: string = null;

  constructor() {}

  ngOnInit(): void {
    const previousDate = this.previousDate && this.previousDate.split('T')[0];
    const currentDate = this.storageMovement.createdAt.split('T')[0];
    this.isSameDayThanPrevious = previousDate && (previousDate === currentDate);

    const avatarUrl = this.storageMovement.createdBy ? this.storageMovement.createdBy.avatarUrl : this.storageMovement.company.avatarUrl;
    this.createdByName = this.getName(this.storageMovement);
    this.createdByAvatarUrl = avatarUrl || 'http://ui-avatars.com/api/?name=' + this.createdByName;
    this.storageMovementType = this.mapStorageMovementType(this.storageMovement.type);
  }

  getName(storageMovement: StorageMovement): string {
    if (storageMovement.createdByName) {
      return storageMovement.createdByName;
    }

    if (storageMovement.createdBy) {
      return storageMovement.createdBy.name;
    }

    return storageMovement.company.name;
  }

  mapStorageMovementType(type: string): string {
    switch (type) {
      case 'entry':
      case 'external_transfer_entry':
      case 'internal_transfer_entry':
        return 'entry';
      case 'removal':
      case 'external_transfer_removal':
      case 'internal_transfer_removal':
        return 'removal';
      default:
        return 'unknown';
    }
  }

  openStorageMovementDetails(): void {
    window.open(`${environment.MOUNTDOOM_2_URL}/#/movimentacoes`, '_blank');
  }

}
